// Predefined player reactions (text + emoji) — a player can only ever send
// one of these exact catalog entries, never free text, so there is no
// moderation/injection surface: the server just needs to check the id is a
// known one and relay it to the other seats (see MeksikoRoom's "reaction"
// message handler).
export interface ReactionDef {
  id: ReactionId;
  emoji: string;
  // "" for the emoji-only reactions (srecan/srce/pozdrav) — shown as a bare
  // emoji bubble above the seat instead of an emoji+text one.
  label: string;
}

export type ReactionId =
  | "angry_small_card"
  | "angry_big_card"
  | "bravo"
  | "svaka_cast"
  | "cestitam_pobeda"
  | "izvini"
  | "pa_zasto"
  | "srecan"
  | "srce"
  | "pozdrav";

export const REACTIONS: ReactionDef[] = [
  { id: "angry_small_card", emoji: "😠", label: "Zašto malom kartom?" },
  { id: "angry_big_card", emoji: "😠", label: "Zašto velikom kartom?" },
  { id: "bravo", emoji: "👏", label: "Bravo" },
  { id: "svaka_cast", emoji: "🤝", label: "Svaka čast" },
  { id: "cestitam_pobeda", emoji: "🤝", label: "Čestitam na pobedi" },
  { id: "izvini", emoji: "😢", label: "Izvini" },
  { id: "pa_zasto", emoji: "😠", label: "Pa zašto!" },
  { id: "srecan", emoji: "😊", label: "" },
  { id: "srce", emoji: "❤️", label: "" },
  { id: "pozdrav", emoji: "👋", label: "" },
];

const REACTION_BY_ID = new Map(REACTIONS.map((r) => [r.id, r]));

export function isReactionId(value: string): value is ReactionId {
  return REACTION_BY_ID.has(value as ReactionId);
}

export function getReactionDef(id: ReactionId): ReactionDef {
  return REACTION_BY_ID.get(id)!;
}
